export const FETCH_VENDORS_REQUEST = "FETCH_VENDORS_REQUEST";
export const FETCH_VENDORS_SUCCESS = "FETCH_VENDORS_SUCCESS";
export const FETCH_VENDORS_FAILURE = "FETCH_VENDORS_FAILURE";

export const FETCH_ALL_VENDORS_REQUEST = "FETCH_ALL_VENDORS_REQUEST";
export const FETCH_ALL_VENDORS_SUCCESS = "FETCH_ALL_VENDORS_SUCCESS";
export const FETCH_ALL_VENDORS_FAILURE = "FETCH_ALL_VENDORS_FAILURE";

export const ADD_VENDOR_REQUEST = "ADD_VENDOR_REQUEST";
export const ADD_VENDOR_SUCCESS = "ADD_VENDOR_SUCCESS";
export const ADD_VENDOR_FAILURE = "ADD_VENDOR_FAILURE";

export const UPDATE_VENDOR_REQUEST = "UPDATE_VENDOR_REQUEST";
export const UPDATE_VENDOR_SUCCESS = "UPDATE_VENDOR_SUCCESS";
export const UPDATE_VENDOR_FAILURE = "UPDATE_VENDOR_FAILURE";

export const DELETE_VENDOR_REQUEST = "DELETE_VENDOR_REQUEST";
export const DELETE_VENDOR_SUCCESS = "DELETE_VENDOR_SUCCESS";
export const DELETE_VENDOR_FAILURE = "DELETE_VENDOR_FAILURE";

export const FETCH_VENDOR_DETAILS_REQUEST = "FETCH_VENDOR_DETAILS_REQUEST";
export const FETCH_VENDOR_DETAILS_SUCCESS = "FETCH_VENDOR_DETAILS_SUCCESS";
export const FETCH_VENDOR_DETAILS_FAILURE = "FETCH_VENDOR_DETAILS_FAILURE";

export const RESET_VENDOR_STATE = "RESET_VENDOR_STATE";
export const CLEAR_VENDOR_DELETE_SUCCESS = "CLEAR_VENDOR_DELETE_SUCCESS";
export const UPDATE_VENDOR_APPROVAL_STATUS_REQUEST =
  "UPDATE_VENDOR_APPROVAL_STATUS_REQUEST";
export const UPDATE_VENDOR_APPROVAL_STATUS_SUCCESS =
  "UPDATE_VENDOR_APPROVAL_STATUS_SUCCESS";
export const UPDATE_VENDOR_APPROVAL_STATUS_FAILURE =
  "UPDATE_VENDOR_APPROVAL_STATUS_FAILURE";

export const FETCH_CUSTOMERS_BY_VENDOR_REQUEST =
  "FETCH_CUSTOMERS_BY_VENDOR_REQUEST";
export const FETCH_CUSTOMERS_BY_VENDOR_SUCCESS =
  "FETCH_CUSTOMERS_BY_VENDOR_SUCCESS";
export const FETCH_CUSTOMERS_BY_VENDOR_FAILURE =
  "FETCH_CUSTOMERS_BY_VENDOR_FAILURE";

export const CONVERT_CUSTOMER_TO_VENDOR_REQUEST =
  "CONVERT_CUSTOMER_TO_VENDOR_REQUEST";
export const CONVERT_CUSTOMER_TO_VENDOR_SUCCESS =
  "CONVERT_CUSTOMER_TO_VENDOR_SUCCESS";
export const CONVERT_CUSTOMER_TO_VENDOR_FAILURE =
  "CONVERT_CUSTOMER_TO_VENDOR_FAILURE";
export const CLEAR_CONVERT_CUSTOMER_TO_VENDOR_STATUS =
  "CLEAR_CONVERT_CUSTOMER_TO_VENDOR_STATUS";
